exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-container[data-v-6de058b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100vh;width:100vw}.b-field[data-v-6de058b0]{margin-bottom:20px}.action-button[data-v-6de058b0],.b-field[data-v-6de058b0],.button[data-v-6de058b0],.input-field[data-v-6de058b0]{width:100%;max-width:400px}@media (max-width:768px){.action-button[data-v-6de058b0],.b-field[data-v-6de058b0],.button[data-v-6de058b0]{max-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6de058b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PasswordReset/PasswordResetPeriodical.vue
// module id = +xjM
// module chunks = 0